import React from "react";
import ErrorAlert from "@/ui/ErrorAlert";
import { Box, Text, VStack } from "@chakra-ui/react";

enum ErrorStockAlertType {
  localProduct = "Producto local",
  reposition = "Reposición",
}

interface ErrorStockAlertProps {
  isOpen: boolean;
  onClose: () => void;
  type: "localProduct" | "reposition";
  relatedVouchers: {
    voucherCode: string;
    usedStock: number;
    productCode: string;
  }[];
}

const ErrorStockAlert: React.FC<ErrorStockAlertProps> = ({
  relatedVouchers,
  isOpen,
  type,
  onClose,
}) => {
  return (
    <ErrorAlert
      isOpen={isOpen}
      onClose={onClose}
      title="Error al actualizar la reposición"
    >
      <VStack align="stretch" gap={4}>
        <Text>
          No se pudo actualizar el registro de {ErrorStockAlertType[type]}{" "}
          debido a que han sido utilizados:
        </Text>
        <VStack maxH="300px" overflowY="auto" align="stretch" gap={3}>
          {relatedVouchers.map((vale, index) => (
            <Box
              key={index}
              bg="bg.subtle"
              p={3}
              borderRadius="md"
              borderWidth="1px"
              borderColor="border"
            >
              <Text fontWeight="bold">Vale: {vale.voucherCode}</Text>
              <VStack
                align="stretch"
                mt={2}
                gap={1}
                fontSize="sm"
                color="fg.muted"
              >
                <Text>Cantidad usada: {vale.usedStock}</Text>
                {vale.productCode && (
                  <Text>Código de producto: {vale.productCode}</Text>
                )}
              </VStack>
            </Box>
          ))}
        </VStack>
      </VStack>
    </ErrorAlert>
  );
};

export default ErrorStockAlert;
